import { motion } from "framer-motion";
import { Leaf, Users, BookOpen, MapPin, Phone, Mail } from "lucide-react";

const LivestockAnimalProduction = () => {
  return (
    <main className="min-h-screen bg-slate-50 text-slate-900">
      <section className="relative overflow-hidden bg-gradient-to-br from-emerald-900 via-green-800 to-slate-950 px-6 py-20 text-white">
        <div className="absolute inset-0 opacity-20" style={{ backgroundImage: 'radial-gradient(circle at 20% 20%, white 0, transparent 24%), radial-gradient(circle at 80% 10%, white 0, transparent 22%)' }} />
        <div className="relative mx-auto max-w-6xl">
          <motion.p initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} className="text-sm font-black uppercase tracking-[0.3em] text-emerald-200">School of Agricultural Technology</motion.p>
          <motion.h1 initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.08 }} className="mt-4 max-w-4xl text-4xl font-black leading-tight md:text-6xl">Department of Livestock and Animal Production Technology</motion.h1>
          <motion.p initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.14 }} className="mt-5 max-w-3xl text-lg leading-8 text-emerald-50">Training practical manpower for livestock management, animal production, farm enterprise, food security and sustainable agricultural development.</motion.p>
        </div>
      </section>

      <section className="mx-auto grid max-w-6xl gap-8 px-6 py-12 lg:grid-cols-[1.2fr_.8fr]">
        <div className="space-y-6">
          <motion.article initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="rounded-3xl bg-white p-8 shadow-sm ring-1 ring-slate-200">
            <h2 className="text-2xl font-black text-slate-950">Department Overview</h2>
            <p className="mt-4 leading-8 text-slate-600">The department focuses on livestock production systems, animal health support practices, feed formulation, poultry, ruminant management, farm records, agribusiness and practical animal husbandry skills for students and industry needs.</p>
          </motion.article>

          <motion.article initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="rounded-3xl bg-white p-8 shadow-sm ring-1 ring-slate-200">
            <h2 className="text-2xl font-black text-slate-950">Learning Areas</h2>
            <div className="mt-6 grid gap-4 md:grid-cols-2">
              {["Animal nutrition and feed technology", "Poultry and ruminant production", "Farm management and enterprise", "Animal health and biosecurity", "Livestock housing and equipment", "SIWES and practical farm work"].map((item) => (
                <div key={item} className="rounded-2xl bg-emerald-50 p-4 font-bold text-emerald-900"><Leaf className="mb-2 h-5 w-5" />{item}</div>
              ))}
            </div>
          </motion.article>
        </div>

        <aside className="space-y-6">
          <div className="rounded-3xl bg-white p-6 shadow-sm ring-1 ring-slate-200">
            <Users className="h-8 w-8 text-emerald-700" />
            <h3 className="mt-4 text-xl font-black">Career Pathways</h3>
            <ul className="mt-4 space-y-3 text-sm font-semibold text-slate-600">
              <li>• Livestock farm manager</li>
              <li>• Poultry production officer</li>
              <li>• Feed mill assistant/manager</li>
              <li>• Animal production entrepreneur</li>
              <li>• Extension and farm support officer</li>
            </ul>
          </div>

          <div className="rounded-3xl bg-slate-950 p-6 text-white shadow-sm">
            <BookOpen className="h-8 w-8 text-emerald-300" />
            <h3 className="mt-4 text-xl font-black">Contact Department</h3>
            <p className="mt-4 flex gap-2 text-sm text-slate-300"><MapPin className="h-4 w-4 shrink-0" /> School of Agricultural Technology, Federal Polytechnic Bida</p>
            <p className="mt-3 flex gap-2 text-sm text-slate-300"><Phone className="h-4 w-4 shrink-0" /> +234 800 000 0000</p>
            <p className="mt-3 flex gap-2 text-sm text-slate-300"><Mail className="h-4 w-4 shrink-0" /> livestock@fedpolybida.edu.ng</p>
          </div>
        </aside>
      </section>
    </main>
  );
};

export default LivestockAnimalProduction;
